import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import techAddReducer from '../views/Scripts/reducers/TechAddReducer';
import reportsReducer from '../views/ReportKpis/reducers/ReportsReducer';
import ticketsReducer from '../views/Tickets/reducers/TicketsReducer';
import configurationReducer from '../views/CM/reducers/ConfigurationReducer';
import cellInfoReducer from '../views/CM/reducers/CellInfoReducer';
import huaweiRemoteAnalysisReducer from '../views/CM/reducers/HuaweiRemoteAnalysisReducer';
import reportPPMranReducer from '../views/SmallCells/reducers/ReportPPMReducer';
import scfReducer from '../views/Scripts/reducers/ScfReducer';
import report2CAReducer from '../views/Acceptance/reducers/Report2CAReducer';
import reportAvailabilityReducer from '../views/SmallCells/reducers/RanReportAvailabilityReducer';
import ReportSmallCellsImpactReducer from '../views/SmallCells/reducers/ReportSmallCellsImpactReducer';
import reportNRReducer from '../views/Acceptance/reducers/ReportNRReducer';
import reportNR7AssessmentReducer from '../views/Acceptance/reducers/ReportNR7AssessmentReducer';
import RETEnablingChecksReducer from '../views/RanRETAudit/reducers/RetAuditReducers';
import RETFilesUploadReducer from '../views/RanRETAudit/reducers/RETFilesUploadReducers';
import incidentTrackerReducer from '../views/IncidentTracker/reducers/IncidentTrackerReducer';
import incidentTrackerConfigurationReducer from '../views/IncidentTracker/reducers/IncidentTrackerConfigurationReducer';
import siteTrackerReducer from '../views/SiteTracker/reducers/SiteTrackerReducer';
import CPMUploadReducer from '../views/RanRETAudit/reducers/CPMFilesUploadReducers';
import RANDumpExportReducer from '../views/RANDumpExport/reducers/RANDumpExportReducers';
import CPMDumpExportReducer from '../views/RanRETAudit/reducers/CPMDumpExportReducers';
import GEOFilesUploadReducer from '../views/RanRETAudit/reducers/GEOInputFileReducer';
import SiteAssessmentReducer from '../views/SiteAssessment7Days/reducers/SiteAssessment7DaysReducers';
import TopOffendersReducers from '../views/TopOffenders/reducers/TopOffendersReducers';
import TopOffendersCitiesReducers from '../views/TopOffendersCities/reducers/TopOffendersCitiesReducers';
import ranReportRFReducer from '../views/RanReportRF/reducers/RanReportRFReducer';
import TopOffendersWorstSitesReducers from '../views/TopOffendersWorstSites/reducers/WorstSitesReducers';
import WorstSitesRegionReducer from '../views/TopOffendersWorstSites/reducers/WorstSitesRegionReducers';
import CapacityPRBBlackListReducers from '../views/CapacityPRBBlackList/reducers/CapacityPRBBlackListReducers';
import TopOffendersWorstSitesCitiesReducers from '../views/TopOffendersWorstSites/reducers/WorstSitesCitiesReducers';
import bwUpdateReducer from '../views/Scripts/reducers/BwUpdateReducer';
import trxReductionReducer from '../views/Scripts/reducers/TrxReductionReducer';
import TopOffendersAggSiteReducer from '../views/TopOffendersGenericReports/reducers/TopOffendersAggSiteReducer';
import TopOffendersAggSubRegionReducer from '../views/TopOffendersGenericReports/reducers/TopOffendersAggSubRegionReducer';
import TopOffendersAggRegionReducer from '../views/TopOffendersGenericReports/reducers/TopOffendersAggRegionReducer';
import TopOffendersAggCityReducer from '../views/TopOffendersGenericReports/reducers/TopOffendersAggCityReducer';
import incidentTrackerDemoReducer from '../views/RFOPTTracker/reducers/IncidentTrackerDemoReducer';
import reportRFCountersReducer from '../views/Acceptance/reducers/ReportRFCountersReducer';
import reportSunsetReducer from '../views/Acceptance/reducers/ReportSunsetReducer';
import FocusOccasionUploadReducer from '../views/FocusOccasion/reducers/FocusOccasionUploadReducers';
import managementReducer from '../views/AcceptanceManagement/reducers/ManagementReducer';
import IncidentCellListReducer from '../views/IncidentCellList/reducers/IncidentCellListReducer';
import MopRanReportReducer from '../views/MopRanReport/reducers/MopRanReportReducer';
import sarpReportReducer from '../views/SarpReport/reducers/SarpReportReducer';
import kpisOverviewReducer from '../views/KPIsOverview/reducers/KPIsOverviewReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	techAddReducer,
	reportsReducer,
	ticketsReducer,
	configurationReducer,
	cellInfoReducer,
	huaweiRemoteAnalysisReducer,
	reportPPMranReducer,
	scfReducer,
	report2CAReducer,
	reportAvailabilityReducer,
	ReportSmallCellsImpactReducer,
	reportNRReducer,
	reportNR7AssessmentReducer,
	RETEnablingChecksReducer,
	RETFilesUploadReducer,
	incidentTrackerReducer,
	incidentTrackerConfigurationReducer,
	siteTrackerReducer,
	RANDumpExportReducer,
	CPMUploadReducer,
	CPMDumpExportReducer,
	GEOFilesUploadReducer,
	SiteAssessmentReducer,
	TopOffendersReducers,
	TopOffendersCitiesReducers,
	ranReportRFReducer,
	TopOffendersWorstSitesReducers,
	CapacityPRBBlackListReducers,
	TopOffendersWorstSitesCitiesReducers,
	WorstSitesRegionReducer,
	bwUpdateReducer,
	trxReductionReducer,
	TopOffendersAggSiteReducer,
	TopOffendersAggSubRegionReducer,
	TopOffendersAggRegionReducer,
	TopOffendersAggCityReducer,
	incidentTrackerDemoReducer,
	reportRFCountersReducer,
	reportSunsetReducer,
	FocusOccasionUploadReducer,
	managementReducer,
	IncidentCellListReducer,
	MopRanReportReducer,
	sarpReportReducer,
	kpisOverviewReducer
});

export default rootReducer;
